import React from "react";
import { Col, Row } from "react-bootstrap";
import { useFormContext } from "react-hook-form";

import { HookFormRadioButton } from "components";
import { OrderNumberTypes } from "types";

type IndustrySectionProps = {
	isLoading: boolean;
	sectionName: string;
	defaultValue: string;
};

const IndustryTypeSection = ({
	isLoading,
	sectionName,
	defaultValue,
}: IndustrySectionProps) => {
	const { register } = useFormContext();

	return (
		<div data-autotest="industryTypeSection">
			<p>Industry Type</p>
			<Row className="form-group">
				<Col md={2}>
					<HookFormRadioButton
						id={`${sectionName}.industryTypeRestaurant`}
						register={register}
						name={`${sectionName}.industryType`}
						value={OrderNumberTypes.Restaurant.value?.toString()}
						defaultCheckedByValue={defaultValue}
						label={OrderNumberTypes.Restaurant.displayName}
						blurLoading={isLoading}
					/>
				</Col>
				<Col md={2}>
					<HookFormRadioButton
						id={`${sectionName}.industryTypeRetail`}
						register={register}
						name={`${sectionName}.industryType`}
						value={OrderNumberTypes.Retail.value?.toString()}
						defaultCheckedByValue={defaultValue}
						label={OrderNumberTypes.Retail.displayName}
						blurLoading={isLoading}
					/>
				</Col>
			</Row>
		</div>
	);
};

export default IndustryTypeSection;
